import React, {Component} from 'react';
import axios from 'axios'
import {BACKEND_BASE_URL} from "../../constants/routes";

class WorkerStats extends Component {


    constructor(props) {
        super(props);
        this.state = { stats: {
            "lefkosa": {
                    "clients": 0,
                    "workers": 0

                },
            "girne": {
                    "clients": 0,
                    "workers": 0

                },
            "magusa": {
                    "clients": 0,
                    "workers": 0

                },
            "lefke": {
                    "clients": 0,
                    "workers": 0
                ,
                "incompleteWorkers": 0,
                "benchWorkers": 0

                }}, error:''}


    }

    componentDidMount() {
        // this.setState({ stats: this.props.stats})
        console.log(this.props+"--00")
        if(this.props.user.access==="Admin") {
            axios.get(`${BACKEND_BASE_URL}/users/workerStats` )
                .then(userStats=>{
                    console.log(userStats.data.data)
                    this.setState({ stats: userStats.data.data})

                })
                .catch(e=>{

                })
        }
    }


    render() {
             const {lefkosa,girne, magusa, lefke,incompleteWorkers, benchWorkers } = this.state.stats? this.state.stats: 0
            const workerTotal = lefkosa.workers + girne.workers + magusa.workers + lefke.workers
        const clientTotal = lefkosa.clients + girne.clients + magusa.clients + lefke.clients
        return (
            <div>
                <section className="content-header">
                    <h1>
                        Dashboard
                        <small>Control panel</small>
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="#"><i className="fa fa-dashboard" /> Home</a></li>
                        <li className="active">Dashboard</li>
                    </ol>
                </section>

                <section className="content">
                    {/* Small boxes (Stat box) */}
                    <div className="row">
                        <div className="col-lg-3 col-xs-6">
                        {/* small box */}
                        <div className="small-box bg-yellow">
                            <div className="inner">
                                <h4>{lefkosa.workers} Workers</h4>
                                <h4>{lefkosa.clients} Clients</h4>
                                {/*<p>Lefkosa</p>*/}
                            </div>
                            <div className="icon">
                                <i className="ion ion-person-add" />
                            </div>
                            <a href="#" className="small-box-footer">Lefkosa <i className="fa fa-arrow-circle-right" /></a>
                        </div>
                    </div>

                        <div className="col-lg-3 col-xs-6">
                            {/* small box */}
                            <div className="small-box bg-fuchsia">
                                <div className="inner">
                                    <h4>{girne.workers} Workers</h4>
                                    <h4>{girne.clients} Clients</h4>
                                    {/*<p>Lefkosa</p>*/}
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">Girne <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>

                        <div className="col-lg-3 col-xs-6">
                            {/* small box */}
                            <div className="small-box bg-red">
                                <div className="inner">
                                    <h4>{magusa.workers} Workers</h4>
                                    <h4>{magusa.clients} Clients</h4>
                                    {/*<p>Lefkosa</p>*/}
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">Magusa <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>

                        <div className="col-lg-3 col-xs-6">
                            {/* small box */}
                            <div className="small-box bg-yellow">
                                <div className="inner">
                                    <h4>{lefke.workers} Workers</h4>
                                    <h4>{lefke.clients} Clients</h4>
                                    {/*<p>Lefkosa</p>*/}
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">Lefke <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>



                        <div className="col-lg-6 col-xs-3">
                            {/* small box */}
                            <div className="small-box bg-yellow">
                                <div className="inner">
                                    <h3>{clientTotal}</h3>
                                    {/*<p>Number of Clients</p>*/}
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">Number of Clients<i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>


                        <div className="col-lg-6 col-xs-3">
                            {/* small box */}
                            <div className="small-box bg-gray-active">
                                <div className="inner">
                                    <h3>{workerTotal}</h3>
                                    {/*<p>Number of Workers</p>*/}
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">Number of Active Workers <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>


                        <div className="col-lg-6 col-xs-3">
                            {/* small box */}
                            <div className="small-box bg-fuchsia">
                                <div className="inner">
                                    <h3>{benchWorkers}</h3>
                                    {/*<p>Number of Workers</p>*/}
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">Number of Bench Workers <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>


                        <div className="col-lg-6 col-xs-3">
                            {/* small box */}
                            <div className="small-box bg-yellow">
                                <div className="inner">
                                    <h3>{incompleteWorkers}</h3>
                                    {/*<p>Number of Workers</p>*/}
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">Number of Incomplete Workers <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>
                        {/* ./col */}

                        {/* ./col */}
                    </div>
                </section>
            </div>
        );
    }
}

export default WorkerStats;